import {
  ensureMsalInitialized,
  msalInstance,
} from '@frontend/features/auth/config/msalInstance';
import { getAuthMode } from '@frontend/features/auth/util/util.auth.getAuthMode';
import { clearLocalToken } from '@frontend/features/auth/util/util.auth.localToken';
import { clearRedirectHandled } from '@frontend/features/auth/util/util.auth.redirectIdempotency';

/**
 * Logs out the current user based on authentication mode
 *
 * **E2E Mode** (token in localStorage):
 * - Clears localStorage token
 * - Redirects to home page to show token exchange page
 *
 * **MSAL Mode** (no token in localStorage):
 * - Uses MSAL logout redirect
 * - Clears MSAL session and redirects to Azure AD logout
 */
export async function logout(): Promise<void> {
  const authMode = getAuthMode();

  // E2E mode: clear localStorage token and reload
  if (authMode === 'e2e') {
    clearLocalToken();
    // Reload page to trigger AuthGuard to show token exchange page
    window.location.href = '/';
    return;
  }

  // MSAL mode: use Azure AD logout
  await ensureMsalInitialized();

  // Clear the redirect handled flag to allow fresh login after logout
  clearRedirectHandled();

  await msalInstance.logoutRedirect();
}
